export interface Team {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  accentLight: string;
}

export const TEAMS: Team[] = [
  {
    slug: "early-moments",
    name: "Early Moments",
    description: "Early moments prototype",
    icon: "sparkles",
    color: "#7066a3",
    accentLight: "#e3e0f2",
  },
  {
    slug: "embedding-brand",
    name: "Embedding Brand",
    description: "Embedding brand prototype",
    icon: "layers",
    color: "#67abc1",
    accentLight: "#d1e6ec",
  },
  {
    slug: "survey",
    name: "Survey",
    description: "Survey team",
    icon: "clipboard-list",
    color: "#f4347f",
    accentLight: "#ffedf3",
  },
  {
    slug: "value-adoption",
    name: "Value Adoption",
    description: "Value adoption team",
    icon: "trending-up",
    color: "#1cb25c",
    accentLight: "#edf9ef",
  },
  {
    slug: "unified-vision",
    name: "Unified Vision",
    description: "Unified vision",
    icon: "eye",
    color: "#d67342",
    accentLight: "#f3d5c6",
  },
];

export const getTeamBySlug = (slug: string): Team | undefined =>
  TEAMS.find((t) => t.slug === slug);

export const isEarlyMoments = (slug: string | null): boolean =>
  slug === "early-moments";
